import { parallelLimit } from 'async';
import CollectionApi from 'client/api/v2/CollectionApi';
import SystemApi from 'client/api/v2/SystemApi';

class SoftwareAppsStatusApi extends CollectionApi {
  constructor(softwareAppId = '') {
    super(`/api/v2/softwareapps/${softwareAppId}/statuses`, {
      skip: 0,
      limit: 50,
      sort: 'state',
      search: {
        fields: [''],
        searchTerm: '',
      },
    });
  }

  fetch(skip, limit, sort, searchTerm, cancelToken, filters, pageToken) {
    const tasks = [];

    return new Promise((resolve, reject) => {
      super.fetch(skip, limit, sort, searchTerm, cancelToken, filters, pageToken)
        .then((response) => {
          const filteredResults = [];
          response.results.forEach((item) => {
            tasks.push((cb) => {
              SystemApi
                .get(item.systemId, cancelToken)
                .then((system) => {
                  if (system) {
                    // eslint-disable-next-line no-param-reassign
                    item.device = system;
                    filteredResults.push(item);
                  }
                  cb();
                }).catch(() => {
                // If unable to look up device for software app results, just
                // continue. The device may have been deleted while its
                // old software apps results are still available.
                  cb();
                });
            });
          }, []);
          parallelLimit(tasks, 5, (error) => {
            if (error) {
              reject(error);
            } else {
              resolve({ results: filteredResults, totalCount: response.totalCount });
            }
          });
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  setSoftwareAppId(softwareAppId) {
    this.baseUrl = `/api/v2/softwareapps/${softwareAppId || ''}/statuses`;
  }
}

export default new SoftwareAppsStatusApi();
